import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=0b343a62&scoped=true&lang=pug&"
import script from "./LazyImage.vue?vue&type=script&lang=ts&"
export * from "./LazyImage.vue?vue&type=script&lang=ts&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=0b343a62&lang=scss&scoped=true&"
import style1 from "./LazyImage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b343a62",
  null
  
)

export default component.exports